import _ from 'lodash'

export default function (attr, defaultValue) {
  return _.get(window.sysConfig, attr, defaultValue)
}



// WEBPACK FOOTER //
// ./src/config.js